import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import DIWRadio from '@/components/diw.radio';

export default class DIWSelectRedirect extends TKSelectRedirect {
    radio?: DIWRadio;

    constructor() {
        super();

        this.radio = this.querySelector('[data-tk-product-variants]') || undefined;
    }

    connectedCallback(): void {
        if (this.asyncURL) {
            this.getData();
        } else if (this.form) this.registerInputListener();
        else {
            if (!this.radio) throw new Error('TKSelectRedirect: Radio element is missing!');
            this.registerRadioListener();
        }
    }

    registerRadioListener(): void {
        const action = this.handleRadio.bind(this);
        this.pushListener({ event: 'change', element: this.radio!, action });
    }

    handleRadio(): void {
        const selectedValue = this.radio!.value;
        if (!selectedValue) return;
        this.redirectByValue(selectedValue);
    }
}
